import {
    AnimatedActionBarModeTransition,
    AutoHideOnScroll,
} from '@/components';
import type { EventsExportControls } from '@/hooks';
import { useQueryResultsStore } from '@/stores';
import { EventsBrowseBar, EventFilter, EventSort } from '@/features/BrowseBar';
import type { EventsBrowseBarConfig } from '@/features/BrowseBar';
import { useQueryAddToReportAction } from '../hooks/useQueryAddToReportAction';
import { useQueryEventsExport } from '../hooks/useQueryEventsExport';
import { SelectionBar } from './SelectionBar';

const QUERY_RESULTS_CONFIG: EventsBrowseBarConfig = {
    filters: [
        EventFilter.CONFIDENCE,
        EventFilter.DATE_RANGE,
        EventFilter.SOURCE,
    ],
    sorts: [EventSort.DATE, EventSort.CONFIDENCE],
    requireSource: true,
};

interface QueryResultsActionBarProps {
    scrollContainer: HTMLDivElement | null;
    visibleEventIds: string[];
    eventExport: EventsExportControls;
}

export function QueryResultsActionBar({
    scrollContainer,
    visibleEventIds,
    eventExport,
}: QueryResultsActionBarProps) {
    const mode = useQueryResultsStore((state) => state.mode);
    const enterSelectionMode = useQueryResultsStore(
        (state) => state.enterSelectionMode,
    );
    const eventsExport = useQueryEventsExport(eventExport);
    const addToReportAction = useQueryAddToReportAction();

    return (
        <AutoHideOnScroll container={scrollContainer}>
            <AnimatedActionBarModeTransition
                isMultiSelectMode={mode === 'selection'}
                browseSlot={
                    <EventsBrowseBar
                        config={QUERY_RESULTS_CONFIG}
                        onEnterMultiSelect={enterSelectionMode}
                    />
                }
                selectionSlot={
                    <SelectionBar
                        visibleEventIds={visibleEventIds}
                        exportBusy={eventsExport.busy}
                        onExport={eventsExport.startExport}
                        bulkActions={[addToReportAction]}
                    />
                }
            />
        </AutoHideOnScroll>
    );
}
